import React from 'react';
import Image from '../../../components/AppImage';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation('about');
  return (
    <section className="relative overflow-hidden min-h-[calc(100vh-80px)] flex items-center">
      <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 via-transparent to-accent/10 pointer-events-none"></div>
      
      {/* Dark theme overlay for perfect text contrast */}
      <div className="absolute inset-0 hero-dark-overlay opacity-70 [data-theme='dark']:opacity-100 pointer-events-none"></div>
      {/* Floating Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none"></div>

      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,5 85,25 85,65 50,85 15,65 15,25" fill="var(--color-accent)" opacity="0.3"/>
          </svg>
        </div>
        <div className="absolute top-40 right-20 w-24 h-24">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,5 85,25 85,65 50,85 15,65 15,25" fill="var(--color-surface)" opacity="0.2"/>
          </svg>
        </div>
        <div className="absolute bottom-20 left-1/3 w-20 h-20">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <polygon points="50,5 85,25 85,65 50,85 15,65 15,25" fill="var(--color-accent)" opacity="0.4"/>
          </svg>
        </div>
      </div>

      <div className="relative container mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          {/* Content */}
          <div className="lg:col-span-7 space-y-6">
            <h1 className="font-heading font-bold text-4xl lg:text-5xl xl:text-6xl text-foreground leading-tight">
              {t('title', 'O kompaniji')}
              <span className="block text-accent mt-2">PC Centar</span>
            </h1>
            
            <p className="text-text-secondary text-lg lg:text-xl leading-relaxed max-w-2xl">
              {t('heroDesc', 'Osnovani 1992. godine kao vodeći distributer IT opreme u Srbiji. Deo ComputerLand grupe kompanija, zvanični zastupnici Xiaomi, Canon, Logitech, Genius, Kingstar, Tecno i Deerma brendova.')}
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-success rounded-full"></div>
                <span className="text-text-secondary font-medium">{t('yearsExp', '33+ godina iskustva')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-accent rounded-full"></div>
                <span className="text-text-secondary font-medium">{t('group', 'ComputerLand Group')}</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="w-3 h-3 bg-warning rounded-full"></div>
                <span className="text-text-secondary font-medium">{t('certifiedPartner', 'Sertifikovani partner')}</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-accent/20 to-surface/20 rounded-2xl transform rotate-3"></div>
              <div className="relative bg-card rounded-2xl p-8 shadow-hexagon">
                <Image
                  src="/assets/images/about-company.webp"
                  alt="PC Centar - Moderna kancelarija i sedište kompanije u Beogradu"
                  className="w-full h-64 lg:h-80 object-cover rounded-xl"
                  // Pošto je ovo Hero, slika treba da se učita odmah
                  loading="eager" 
                />
                <div className="absolute -bottom-4 -right-4 bg-accent text-accent-foreground px-6 py-3 rounded-xl shadow-elevation">
                  <span className="font-heading font-bold text-2xl">1992</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;